import AnimationClip from '../AnimationClip';
import { Tween, Easing } from '@tweenjs/tween.js';
import GameObject from '../../../GameObject/GameObject';
import ElementComponent from '../../../Component/UI/Element';
import Renderable from '../../../Component/Renderable';

export class MenuHide extends AnimationClip {
    public *execute(
        gameObject: GameObject,
        meta?: any
    ): IterableIterator<number> {
        const renderable: Renderable = gameObject.getComponent(Renderable);
        const element: ElementComponent = gameObject.getComponent(
            ElementComponent
        );

        renderable.visible = true;
        element.anchors = [0, 0, 1, 1];

        const moveDownTween: Tween = this.getTween(element);

        moveDownTween
            .to({ anchorX1: 0, anchorY1: 1, anchorX2: 1, anchorY2: 2 }, 300)
            .easing(Easing.Quadratic.Out);

        yield* this.startTween(moveDownTween);

        renderable.visible = false;
    }
}
